import React, { useContext, useCallback, useMemo } from "react";
import { View, StyleSheet, FlatList, Text } from "react-native";
import Icon from "react-native-vector-icons/Feather";

import { CallsContext } from "../../contexts/CallsContext";

import IconButton from "~/components/Buttons/IconButton/index";
import palette from "../../styles/palette";
import Row from "~/layouts/Row";
import Col from "~/layouts/Col";
import { getSmartTimestamp } from "../../helpers/day";
import dayjs from "~/helpers/day";
import useTwilio from "~/hooks/useTwilio";

const CallLogList = ({ style = {} }) => {
  const { loading, calls, getCalls, refreshCalls, nextPage } =
    useContext(CallsContext);

  const refreshCallLogsListOnFocus = useCallback(() => {
    refreshCalls();
  }, [refreshCalls]);

  // useFocusEffect(refreshCallLogsListOnFocus);
  // console.log(JSON.stringify(calls[0], null, 2));

  return (
    <View style={[styles.container, style]}>
      <FlatList
        data={calls}
        refreshing={loading}
        onRefresh={getCalls}
        renderItem={renderCallListItem}
        showsVerticalScrollIndicator={false}
        keyExtractor={(item) => `call-list-item-${item.id}`}
        onEndReachedThreshold={0.9}
        onEndReached={nextPage}
      />
    </View>
  );
};

const renderCallListItem = (props) => {
  return <CallListItem {...props} />;
};
const CallListItem = ({ item }) => {
  // const navigation = useNavigation();
  const { startCall, activeCall } = useTwilio();

  const duration = dayjs.duration(item.meta?.duration || 0, "seconds");
  const mins = duration.format("m");
  const secs = duration.format("s");

  const phoneNumber = useMemo(() => {
    const { to, from, direction } = item;

    if (direction === "inbound") {
      return from;
    }

    return to;
  }, [item]);

  const onCallPress = () => {
    startCall(phoneNumber, item.author);
  };

  const iconProps = useMemo(() => {
    if (item.missed) {
      return {
        name: "phone-missed",
        color: palette.danger,
      };
    }

    if (item.direction === "inbound") {
      return {
        name: "phone-incoming",
        color: palette.grey,
      };
    }

    return {
      name: "phone-outgoing",
      color: palette.grey,
    };
  }, [item]);

  return (
    <View style={[styles.call_log_list__item]}>
      <Row style={{ height: "100%" }}>
        <Col rightCenter maxWidth={24} pr={8}>
          <Icon {...iconProps} size={16} />
        </Col>
        <Col>
          <Row style={{ height: "100%" }}>
            <Col leftCenter minWidth={100}>
              <Text
                numberOfLines={1}
                style={[
                  styles.call_log_list__item_name,
                  item.missed && styles.call_log_list__item_missed,
                ]}
              >
                {item.author?.name}
              </Text>
              <Text
                numberOfLines={1}
                style={[
                  styles.call_log_list__item_duration,
                  item.missed && styles.call_log_list__item_missed,
                ]}
              >
                {item.missed && "Missed"}
                {!item.missed && mins !== "0" && `${mins} minutes `}
                {!item.missed && secs !== "0" && `${secs} seconds`}
              </Text>
            </Col>

            <Col rightCenter maxWidth={100}>
              <Text numberOfLines={1}>{getSmartTimestamp(item.createdAt)}</Text>
            </Col>

            <Col rightCenter maxWidth={50}>
              <IconButton
                mr={0}
                iconName="phone"
                disabled={!!activeCall}
                onPress={onCallPress}
                iconColor={!!phoneNumber ? palette.success : palette.light_grey}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  call_log_list__item: {
    height: 65,
    paddingHorizontal: 16,
    paddingRight: 8,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: palette.light_grey,
  },
  call_log_list__item_name: {
    fontWeight: "600",
    fontSize: 16,
  },
  call_log_list__item_duration: {
    fontSize: 12,
  },
  call_log_list__item_missed: {
    color: palette.danger,
  },
});

export default CallLogList;
